import CouponCard from './CouponCard';
import GeneratedCouponsTable from './GeneratedCouponsTable';

const CouponCards = ({ coupons, source, refresh }) => {
  if (source === 'generated') {
    return <GeneratedCouponsTable coupons={coupons} refresh={refresh} />;
  }
  return coupons.map((coupon) => {
    return <CouponCard key={coupon.id} coupon={coupon} />;
  });
};

export default CouponCards;
